import { Directive, ElementRef, EventEmitter, Output, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[visible]'
})
export class VisibleDirective implements AfterViewInit {
  @Output() visible = new EventEmitter<void>();

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.visible.emit();
          observer.unobserve(this.el.nativeElement); // only once
        }
      },
      { threshold: 0.5 } // element is 50% visible
    );

    observer.observe(this.el.nativeElement);
  }
}
